import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import { memoryContextQueryOptions } from "./memory.queries";

// Prefix-invalidate every cached directory after a write (key ["memory","files",parentId]).
const invalidateFiles = () => queryClient.invalidateQueries({ queryKey: ["memory", "files"] });

export const uploadFilesMutation = mutationOptions({
	mutationFn: (form: FormData) => api.upload("/platform/memory/files", form),
	onSuccess: invalidateFiles,
});

export const createFolderMutation = mutationOptions({
	mutationFn: (vars: { name: string; parentId: string | null }) =>
		api.post("/platform/memory/folders", vars),
	onSuccess: invalidateFiles,
});

// rename / move / paste all patch a node.
export const updateNodeMutation = mutationOptions({
	mutationFn: (vars: { id: string; patch: { name?: string; parentId?: string | null } }) =>
		api.post(`/platform/memory/nodes/${vars.id}`, vars.patch),
	onSuccess: invalidateFiles,
});

// A null `beforeId` drops the node at the end.
export const reorderNodeMutation = mutationOptions({
	mutationFn: (vars: { id: string; beforeId: string | null }) =>
		api.post(`/platform/memory/nodes/${vars.id}/reorder`, {
			beforeId: vars.beforeId,
		}),
	onSuccess: invalidateFiles,
});

export const deleteNodeMutation = mutationOptions({
	mutationFn: (id: string) => api.del(`/platform/memory/nodes/${id}`),
	onSuccess: invalidateFiles,
});

export const saveContextMutation = mutationOptions({
	mutationFn: (context: string) => api.post("/platform/memory/context", { context }),
	onSuccess: () =>
		queryClient.invalidateQueries({
			queryKey: memoryContextQueryOptions.queryKey,
		}),
});
